import { ref } from 'vue'
import { AbilityBuilder, createMongoAbility, createAliasResolver } from '@casl/ability'

const builder = new AbilityBuilder(createMongoAbility)

const ability = ref(builder.build({
  resolveAction: createAliasResolver({
    crud: ['create', 'read', 'update', 'delete']
  })
}))

export default function useAbility() {
  return {
    ability,
    updateRules(rules) {
      ability.value.update(rules)
    }
  }
}
